export default "__VITE_ASSET__Dp_SE4wB__"